/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import NewYHConstract from '@/mixins/constracts';
import { Component, Mixins } from 'vue-property-decorator';

const style = require('./index.module.scss');

@Component({ name: 'YHPreApplyChoose' })
export default class YHPreApplyChoose extends Mixins(NewYHConstract) {
  private render() {
    return (
      <div class={style.YHPreApplyChoose}>
        <p class={style.title}>
          <strong>《个人信用报告查询授权书》</strong>
        </p>
        <p>
          <span>
            尊敬的用户:基于“臻有钱”服务，为了维护您的权益，我们提醒您点击确认了《个人信用报告查询授权书》(以下简称”本授权书")即视为您已阅读本授权书所有条款，并对本授权书各项条款的含义及相应的法律后果已全部通晓并充分理解，同意接受本授权书的约束。请您务必关注您在授权书中的权利、义务，珍惜个人信用。
          </span>
        </p>
        <p>
          <p>一、授权内容</p>
          <p>
            授权人(亦称“本人”)同意向{this.constractForm.funderName || ''}
            (以下简称”被授权人”)郑重授权如下:
          </p>
          <p>
            &nbsp;
            1.同意被授权人在办理下列业务时，通过金融信用信息基础数据库、被授权人合作的依法设立的第三方征信机构（包括百行征信有限公司、朴道征信有限公司））合法途径采集、查询、打印、使用、保存、提供、上报本人的个人相关信息（包括但不限于征信信息、财产信息、联络方式、关系人、资信状况、就业情况、收入情况、婚姻情况、学历信息、地址信息等），并保证不会因上述机构或单位配合提供有关信息或确认事项而向上述机构或单位以任何形式提出权利主张。
          </p>
          <p>&nbsp;&nbsp; (1) 审核本人贷款及其他信贷业务申请的;</p>
          <p>&nbsp;&nbsp; (2) 审核本人作为担保人或共同还款人的;</p>
          <p>&nbsp;&nbsp; (3) 对已发放的本人信贷进行货后风险管理的;</p>
          <p>
            &nbsp;&nbsp;
            (4) 受理法人。其他组织或自然人(以下合称”信贷申请人)的信贷申请人或对信贷申请人在被授权人处的信贷进行货后风险管理时，需要查询本人作为信贷申请人的法定代表人、出资人或关联方的信用状况的。
          </p>
          <p>&nbsp;&nbsp;（5）核查本人征信异议;</p>
          <p>&nbsp; 2.授权期限</p>
          <p>
            &nbsp;&nbsp;
            (1]若属于上述1中的第(1)、(2)、(3)项情形之一的，授权期限为自本授权书生效之日起至本人该笔授信在被授权人处到期且债务完全履行完毕之日为止;
          </p>
          <p>
            &nbsp;&nbsp;
            (2)若属于上述1中的第(4)项情形的，授权期限为自本授权书生效之日起至信贷申请人该笔授信在被授权人处到期且债务完全履行完毕之日止。
          </p>
          <p>二、授权书的形式</p>
          <p>
            授权人同意本授权书以数据电文形式订立;授权人一旦在线确认本授权书，本授权书即生效。为数据电文存证需要并保证签署数据电文合同文本的真实、完整、不可篡改，您不可撤销地授权贷款人合作的电子签名服务机构根据您提供的个人信息向取得认证资格的电子认证机构申请电子签章，您已知晓您的电子签章将由电子认证机构保管，并同意在借款申请过程中根据您发出的指令（即您点击确认合同文本动作本身）自动调取及在您确认签署的合同文本中使用您的电子签章。
          </p>
          <p>三、责任约定</p>
          <p>
            本人确认对本授权书的条款含义及相应的法律后果已全部知晓并充分理解。被授权人可查询和使用信用报告期间，不应超过本授权书授权期限终止之日。被授权人超出授权查询的一切后果及法律责任由被授权人承担
          </p>
          <p>
            若本人在被授权人处办理的业务未获批准，本人同意被授权人继续保留此查询授权书和相应身份及申请所留信息。
          </p>
        </p>
        <p>授权人: {this.constractForm.userName || ''}</p>
        <p>证件号码: {this.constractForm.idCard || ''}</p>
        <p>授权书生效日期: {this.constractForm.effectiveDate || ''}</p>
      </div>
    );
  }
}
